
import React, { Component } from 'react';
import { formatCSS } from '../cssHelper';

import mapPng from '../../assets/images/swedenMap.PNG';

/**
* Component for html field
* @author   Aleksandar Dabic
*/
class Map extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div style={{...formatCSS(this.props.style), position: 'relative'}}>
                {
                    this.props.style.borderTopLeftRadius || this.props.style.borderTopRightRadius ||
                        this.props.style.borderBottomLeftRadius || this.props.style.borderBottomRightRadius ?
                        <InverseRadius style={this.props.style} />
                        :
                        null


                }

                <img src={mapPng} style={{width: '100%', height: '100%', objectFit: 'cover' }} />

            </div>




        );
    }
}

export default Map;